
export default function isMobilePage(path) {
  const currentPath = path || window.location.pathname;
  return typeof currentPath === 'string' && currentPath.startsWith('/mobile');
}
